import * as api from "@/api/williams/project";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useProjectLookup(search: string) {
  return useQuery(queryKeys.project.search(search), () => {
    return api.getProjectLookup(search);
  });
}
